var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompensationFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M22 12.427c0 3.492-1.5 6.086-4 8.106-1-3.535-2-6.565-2-6.565l-2 .505-1.5-4.544v-2.02l3.5-1.01-4.5-2.02v5.05L9 13.463l-.5 2.02-2 1.515-1.575 2.573C1.728 16.338 1.078 11.34 3.341 7.383c2.263-3.957 6.874-5.887 11.245-4.705 4.37 1.181 7.411 5.18 7.414 9.749zm-7 2.551l1.575 6.474c-.16.053-.32.16-.479.215L14.5 15.988l-2 .505-.5-3.03-1 1.01-.5 2.525-2.809 1.123-1.276 2.686a4.675 4.675 0 01-.532-.379l1.596-2.954 2.521-.98.5-2.526 1.5-2.02 1 3.535 2-.505z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompensationFill);
export default __webpack_public_path__ + "591408d316a05cfe7d18cfeba74e29b9.svg";
export { ForwardRef as ReactComponent };